// src/Pages/Split/splitTokens.js
// ─────────────────────────────────────────────────────────────────────────
// Blitz Split — shared brand tokens, animations, and formatters.
// One source of truth: the header button, every Split component, and any
// future Split surface import from here. Ink-on-yellow everywhere; never
// white on yellow.
// ─────────────────────────────────────────────────────────────────────────

import { alpha, keyframes } from "@mui/material/styles";

export const SPLIT_YELLOW      = "#FFC400";
export const SPLIT_YELLOW_DARK = "#E6AC00";
export const SPLIT_YELLOW_DEEP = "#C79200";
export const SPLIT_INK         = "#1A1A0E";
export const SPLIT_TINT        = alpha(SPLIT_YELLOW, 0.08);
export const SPLIT_BORDER      = alpha(SPLIT_YELLOW, 0.45);

export const SLICE_COLORS = [
  "#FFC400", "#FF9D00", "#FFB733", "#E6AC00", "#FFD45E", "#D99E00",
];

export const TERMS = [
  { value: 30, label: "Net 30" },
  { value: 45, label: "Net 45" },
  { value: 60, label: "Net 60" },
  { value: 90, label: "Net 90" },
];

export const fadeUp = keyframes`
  from { opacity:0; transform:translateY(8px); }
  to   { opacity:1; transform:translateY(0);   }
`;
export const fadeIn = keyframes`from{opacity:0}to{opacity:1}`;
export const popIn  = keyframes`
  from { opacity:0; transform:scale(0.7); }
  to   { opacity:1; transform:scale(1);   }
`;

export const fmt = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v || 0);

export const isEmailish = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((s || "").trim());